module.exports = __webpack_public_path__ + "static/media/logo_interact.4d9ebe35.webp";